<template lang="pug">
    Modal
        .form
            h2(
              v-if="!selectedRole"
            ) Create a New Role
            h2(
              v-if="selectedRole"
            ) Manage Role
            .form__control-group
                label Title
                input(
                    v-model="title"
                    type="text"
                    placeholder="Title"
                )
            .form__control-group
                label Privileges
                div(
                  v-for="p in Object.keys(privileges)"
                )
                  span.role-label
                    i(
                      :class="`glyphicon glyphicon-${roles[p].icon}`"
                    )
                    span {{ roles[p].label }}
                  select(
                    v-model="privileges[p]"
                  )
                    option(
                      value="read"
                    ) read
                    option(
                      value="write"
                    ) write
                    option(
                      value="admin"
                    ) admin
            button.button__submit(
              @click="submit"
              v-if="!selectedRole"
            ) Create Role
            button.button__submit(
              @click="submit"
              v-if="selectedRole"
            ) Update Role
            p.validation__error(
                v-if="showError"
            ) Please enter a Title
</template>
<script>
import Modal from '../general/Modal';
import store from '../../store';
import { postResource } from '../../services/Utils';
import Services from '../../services/Services';
import VueNotifications from 'vue-notifications';

const roles = {
  actionCards: {
    label: 'Action Cards',
    icon: 'edit',
  },
  markets: {
    label: 'Markets',
    icon: 'globe',
  },
  media: {
    label: 'Media',
    icon: 'film',
  },
  mediaLibraries: {
    label: 'Media Libraries',
    icon: 'th',
  },
  policies: {
    label: 'Policies',
    icon: 'bell',
  },
  products: {
    label: 'Products',
    icon: 'tags',
  },
  productGroups: {
    label: 'Product Groups',
    icon: 'inbox',
  },
  roles: {
    label: 'Roles',
    icon: 'briefcase',
  },
  sequences: {
    label: 'Sequences',
    icon: 'tasks',
  },
  users: {
    label: 'Users',
    icon: 'user',
  },
  tenant: {
    label: 'Team',
    icon: 'cog',
  },
}

export default {
  name: 'ManageRole',
  components: {
    Modal
  },
  props: [
    'selectedRole',
    'close',
    'refreshRoles',
  ],
  computed: {
    getMarkets() {
      return store.getters.getMarkets;
    }
  },
  data() {
    return {
      showError: false,
      title: '',
      privileges: {
        actionCards: 'read',
        markets: 'read',
        media: 'read',
        mediaLibraries: 'read',
        policies: 'read',
        products: 'read',
        productGroups: 'read',
        roles: 'read',
        sequences: 'read',
        users: 'read',
        tenant: 'read',
      },
      roles,
    };
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  methods: {
    submit() {
      const body = {
        title: this.title,
        privileges: this.privileges,
      };
      const action = `/v1/tenants/roles/${this.selectedRole ? 'update' : 'create'}`;
      const query = this.selectedRole ? `roleId=${this.selectedRole._id}` : false;
      console.log(query);
      postResource(action, query, body)
        .then((res) => {
          console.log(res);
          this.showSuccessMsg({ message: `${this.title} role ${this.selectedRole ? 'updated' : 'created'}!` });
          this.refreshRoles();
          this.close('manageRole');
        })
        .catch(error => console.log(error));
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.selectedRole) {
        this.title = this.selectedRole.title;
        this.privileges = this.selectedRole.privileges;
      }
    });
  }

};
</script>
<style lang="scss" scoped>
.form {
  padding: 2rem;
  display: flex;
  // align-items: center;
  justify-content: center;
  flex-direction: column;

  h2 {
    text-align: center;
    width: 100%;
  }

  .form__control-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    width: 100%;

    label {
      margin-bottom: 5px;
    }

    &:after {
      top: 20px !important;
    }

    input {
      padding-left: 0.5rem;
      height: 40px;
    }

    div {
      padding: 10px;
      display: flex;
      flex-flow: row nowrap;

      &:nth-of-type(odd) {
        background: #e8ffff;
      }

      span.role-label {
        margin-right: auto;

        i {
          color: #888;
        }

        span {
          margin-left: 10px;
        }
      }

      select {
        width: 100px;
      }
    }

  }
}
</style>






// WEBPACK FOOTER //
// src/components/modals/ManageRole.vue